const normalizeHostname = (hostname) => String(hostname || "").trim().toLowerCase().replace(/\.$/, "");

export const PUBLIC_SITE_HOSTNAME = normalizeHostname(process.env.REACT_APP_PUBLIC_HOSTNAME || "akas.web.id");
export const PUBLIC_SITE_URL = String(
  process.env.REACT_APP_PUBLIC_SITE_URL || `https://${PUBLIC_SITE_HOSTNAME}`,
).replace(/\/$/, "");

export const isPublicSiteHostname = (hostname, publicHostname = PUBLIC_SITE_HOSTNAME) => {
  const current = normalizeHostname(hostname);
  const canonical = normalizeHostname(publicHostname);

  if (["localhost", "127.0.0.1", "::1"].includes(current)) {
    return true;
  }

  return current === canonical || current === `www.${canonical}`;
};

export const isTenantHostname = (hostname, publicHostname = PUBLIC_SITE_HOSTNAME) =>
  !isPublicSiteHostname(hostname, publicHostname);

export const getPublicSiteUrl = (hostname = typeof window === "undefined" ? "" : window.location.hostname) =>
  ["localhost", "127.0.0.1", "::1"].includes(normalizeHostname(hostname)) ? "/" : PUBLIC_SITE_URL;
